/// <reference types="vite-plugin-svgr/client" />
import React, { FC, useMemo } from "react";

import MauLogo from "./mau_logo.svg";

interface MauSocialLinkProps {
  login: string;
  name: string;
}

const MauSocialLink: FC<MauSocialLinkProps> = ({ login, name }) => {
  const link = useMemo(
    () => `https://www.missionartists.org/artists/${login}`,
    [login],
  );
  const label = `Mission Artist's page for ${name}`;
  return (
    <a
      title={label}
      aria-label={label}
      className="mau-social-link"
      href={link}
      target="_blank"
      rel="noreferrer"
    >
      <img src={MauLogo} />
    </a>
  );
};

export { MauSocialLink };
